// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h3EQp","title":"styles_title__Wk7Bo"};